// /home/clement/compta-app/client/src/api/factureApi.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchFacturesAchat = async () => {
  const response = await axios.get(`${API_URL}/factures-achat`);
  return response.data;
};

export const fetchFacturesProjet = async (projetId) => {
  const response = await axios.get(`${API_URL}/projet/${projetId}`);
  return response.data;
};

export const fetchFactureAchatById = async (id) => {
  const response = await axios.get(`${API_URL}/factures-achat/${id}`);
  return response.data;
};

export const createFactureAchat = async (factureData) => {
  const response = await axios.post(`${API_URL}/factures-achat`, factureData);
  return response.data;
};

export const updateFactureAchat = async (id, factureData) => {
  const response = await axios.put(`${API_URL}/factures-achat/${id}`, factureData);
  return response.data;
};

export const deleteFactureAchat = async (id) => {
  await axios.delete(`${API_URL}/factures-achat/${id}`);
};
